import { createOtherIncidentHttpRepository } from '@src/main/modules/other_incidents/infrastructure/OtherIncidentHttpRepository';
import { TokenProvider } from '@src/main/shared/infrastructure/entity/axios';

type UpdateIncidentCategorizationParams = {
  id: string;
  categorization: string;
  idAnswered?: string;
  fullNameAnswered?: string;
  dateAnswered?: string;
};

export const updateIncidentCategorizationUseCase = async (
  {
    id,
    categorization,
    idAnswered,
    fullNameAnswered,
    dateAnswered,
  }: UpdateIncidentCategorizationParams,
  tokenProvider: TokenProvider,
): Promise<void> => {
  const repository = createOtherIncidentHttpRepository(tokenProvider);

  await repository.updateIncident({
    id,
    categorization,
    idAnswered,
    fullNameAnswered,
    dateAnswered,
  });
};
